// @ts-nocheck
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Chart from 'react-apexcharts'
import { useQuery } from '@apollo/client'
import { CubeLoader } from '@/components/ui/cube-loader'
import { useChart } from '@/utils/chart-hook'
import { GET_SENTIMENT } from '@/graphql/publisher-dashboard-queries'

const SentimentAnalysisPieChart = ({ name }) => {
    const { id } = useParams()
    const campaign = useQuery(GET_SENTIMENT, {
        variables: id ? { where: { id } } : {},
    })
    const [series, setSeries] = useState([])

    const { options } = useChart('donut', campaign?.data?.campaigns?.[0]?.sentiment, [
        'positive',
        'neutral',
        'negative',
    ])

    options.colors = ['#41D8B3', '#2C55DB', '#DC402D']
    options.labels = ['Positive', 'Neutral', 'Negative']

    useEffect(() => {
        if (campaign?.data?.campaigns?.[0]?.sentiment) {
            setSeries(campaign.data.campaigns[0].sentiment)
        }
    }, [campaign])

    if (campaign.loading) return <div className="col-md-12 col-xl-5"><CubeLoader size="sm" /></div>

    return (
        <div className="col-md-12 col-xl-5">
            <div className="card" data-aos="fade-up" data-aos-delay="1000">
                <div className="card-header d-flex justify-content-between flex-wrap">
                    <div className="header-title">
                        <h6 className="card-title">{name}</h6>
                    </div>
                </div>
                <div className="card-body">
                    <Chart className="d-activity" options={options} series={series} type="donut" height="300" />
                </div>
            </div>
        </div>
    )
}

export default SentimentAnalysisPieChart
